import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { colors } from '../../../utils/theme';

export type DividerOwnProps = {
    style?: StyleProp<ViewStyle>;
} & (
    | {
          horizontal: true;
      }
    | {
          vertical: true;
      }
);

export type DividerProps = DividerOwnProps;

const Divider: React.FC<DividerProps> = (props) => {
    const isHorizontal = 'horizontal' in props;
    return (
        <View
            style={[
                {
                    height: !isHorizontal ? '100%' : 1,
                    width: isHorizontal ? '100%' : 1,
                    backgroundColor: colors.Dividers,
                },
                props.style,
            ]}
        />
    );
};

export default React.memo(Divider);
